import React from 'react';

import { SpacingBox, H3 } from '../../Components';
import { getTranslateByScope } from '../../i18n';

import SelectCustomerDropdown from '../SelectCustomerDropdown';

const translate = getTranslateByScope('app.selectCustomer');

export const CustomerDropdownWithSearch = ({ selectCustomer }) => (
    <>
      <SpacingBox marginBottom="md">
        <H3>{translate('title')}</H3>
      </SpacingBox>
      <SelectCustomerDropdown selectCustomer={selectCustomer} />
    </>
);

export default CustomerDropdownWithSearch;
